import * as React from "react";
const SvgBookmark = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 21V3h14v18l-7-3-7 3Z",
  fill: "currentColor"
}));
export default SvgBookmark;